import React, { useState } from "react";
import { motion } from "framer-motion";
import { Calendar } from "lucide-react";
import { useLanguage } from "../../context/LanguageContext";
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";

export default function AnimatedButton({
  children,
  onClick,
  disabled = false,
  primary = false,
  icon = false,
  className = "",
}) {
  const [isHovered, setIsHovered] = useState(false);
   const {t,isRTL} = useLanguage();
  const buttonVariants = {
    hover: {
      scale: 1.02,
      y: -2,
      transition: { duration: 0.3 },
    },
    tap: { scale: 0.98 },
  };

  return (
    <motion.button
      whileHover="hover"
      whileTap="tap"
      variants={buttonVariants}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      className={`relative px-6 sm:px-8 py-3 sm:py-4 rounded-xl font-bold text-sm sm:text-base lg:text-lg border border-white transition-all duration-500 overflow-hidden flex-1 ${
        primary
          ? disabled
            ? "bg-gray-400 cursor-default text-white"
            : "bg-cardColor text-primary hover:bg-primary  hover:text-white border-1 border-primary shadow-2xl shadow-secondary/25"
          : disabled
          ? "bg-gray-400 cursor-default text-white border-gray-400 border-2"
          : "border-2 border-white text-white hover:bg-secondary backdrop-blur-sm shadow-2xl hover:shadow-white/25"
      } ${className}`}
    >
      {primary && !disabled && (
        <motion.div
          className="hidden md:flex md:absolute md:inset-0 md:bg-secondary_hover"
          initial={{ x: isRTL?"100%":"-100%" }}
          animate={{ x: isHovered ? "0%" : isRTL?"100%":"-100%" }}
          transition={{ duration: 0.3 }}
        />
      )}

      <span className="relative z-10 flex items-center justify-center gap-2 sm:gap-3">
        {children}
        {primary && !disabled &&!icon&& (
isRTL?<FaArrowLeftLong/>      :<FaArrowRightLong className=""/>    
        )}
        {primary && !disabled &&icon&& (
         <Calendar  className={`${isHovered ? "text-primary" : "text-primary"} w-4 h-4 md:w-6 md:h-6  md:text-lg`}/>
        )}

      </span>
    </motion.button>
  );
}